//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { systemFormDeleteApi, systemFormPageApi } from '@/api/systemForm';
import { handleDeleteTable } from '@/libs/public';
import { useProduct } from '@/hooks/use-product';
import { checkPermi } from '@/utils/permission';
import * as $constants from '@/utils/constants';
var _useProduct = useProduct(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
export default {
  name: 'systemFormIndex',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20
      }
    };
  },
  mounted: function mounted() {
    if (checkPermi(['distribution:system:form:page'])) this.getList();
  },
  methods: {
    checkPermi: checkPermi,
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      systemFormPageApi(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.$store.commit('mobildConfig/SET_SystemForm', res.list);
        localStorage.setItem('systemFormList', JSON.stringify(res.list));
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
        _this.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //删除
    handlerDelete: function handlerDelete(id) {
      var _this2 = this;
      this.$modalSure('确定要删除此表单吗？').then(function () {
        systemFormDeleteApi(id).then(function (res) {
          _this2.$message.success('删除成功');
          handleDeleteTable(_this2.tableData.data.length, _this2.tableFrom);
          _this2.$store.commit('mobildConfig/SET_SystemForm', []);
          _this2.getList();
        });
      });
    },
    //创建、编辑表单
    handlerCreatFrom: function handlerCreatFrom(id, type) {
      handlerCreatFromUse(id, type);
    }
  }
};